const f = new Proxy(x => x, {
  get: (_, prop) => x => x[prop],
})

const pluck = (array, key) => array.map(f[key])
const renameFile = (url, add) => {
  const extension = `.${url.split('.').pop()}`
  const [fileName] = url.split(extension)
  return `${fileName}_${add}${extension}`
}
const checkCurrentRouteAndRedirect = (router, path) => {
  const {
    currentRoute: { path: curPath },
  } = router
  if (curPath !== path) router.push({ path })
}

export default {
  pluck,
  renameFile,
  checkCurrentRouteAndRedirect,
}
